import { FC } from 'react'

import { dateToLocalDateTimeString } from 'utils'

export interface CardAuditLineProps {
  lastModifiedBy?: string
  lastModifiedOn?: string
}

/** BDL20-4262: who last touched a recipient group and when (local time). */
export const CardAuditLine: FC<CardAuditLineProps> = ({
  lastModifiedBy,
  lastModifiedOn,
}: CardAuditLineProps) => {
  const when = dateToLocalDateTimeString(lastModifiedOn)
  if (!lastModifiedBy && !when) {
    return (
      <span className='text-[11.5px] text-N-400'>
        No change history recorded
      </span>
    )
  }
  return (
    <span className='text-[11.5px] text-N-400'>
      Last changed by{' '}
      <span className='text-N-600 font-semibold'>
        {lastModifiedBy || 'Unknown'}
      </span>
      {when ? ` on ${when}` : ''}
    </span>
  )
}

export default CardAuditLine
